import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";

export const settingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatePassword: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/users/${data.id}/change-password`,
        method: "POST",
        body: { ...data },
      }),
    }),
  }),
});

export const { useUpdatePasswordMutation } = settingsApiSlice;
